import { computed, ref } from '@vue/composition-api';
import { ITableOptions } from '@/bundles/BaseTable/interfaces';

interface IUsePagination {
  sortBy?: string[];
  sortDesc?: boolean[];
}

export function usePagination ({ sortBy = [], sortDesc = [] }: IUsePagination = {}) {
  const tableOptions = ref<ITableOptions>({
    groupBy: [],
    groupDesc: [],
    itemsPerPage: 50,
    multiSort: false,
    mustSort: false,
    page: 1,
    sortBy: [...sortBy],
    sortDesc: [...sortDesc],
    itemsPerPageOptions: [
      { title: '50', value: 50 },
      { title: '100', value: 100 },
      { title: '250', value: 200 },
      { title: '500', value: 500 },
      { title: '750', value: 750 },
      { title: '1000', value: 1000 },
    ]
  });
  const pageOffset = computed<number>(() => (tableOptions.value.page - 1) * tableOptions.value.itemsPerPage);

  function optionsChangeEventHandler(options: ITableOptions) {
    tableOptions.value = { ...options };
  }

  return {
    tableOptions,
    pageOffset,
    optionsChangeEventHandler,
  };
}
